import { IntegrationErrorMain } from 'pages/IntegrationError/IntegrationErrorMain'
import { SubscriptionPlanPage } from 'pages/SubscriptionPlanPage'
import { TemplateDetailPage } from 'pages/TemplateDetailPage'
import AccountingPage from '../components/AccountingPage'
import CustomerDetailsPage from '../components/CustomerDetailsPage'
import ExternalPage from '../components/ExternalPage'
import InboxPage from '../components/InboxPage'
import SearchResultPage from '../components/SearchResultsPage'
import RollingCreditAdapter from '../pages/RollingCredit'
import routes from './constants'
import type { Permissions } from 'appPermissions'
import { SpendConrolTableInjected } from 'SpendControl'

type ProtectedRoute = {
  path: string
  component: () => JSX.Element
  fullScreenWidth?: boolean
  permissions?: Permissions[]
}

export const protectedRoutes: ProtectedRoute[] = [
  {
    path: `/spend-controls`,
    component: () => <SpendConrolTableInjected />,
    fullScreenWidth: true,
    permissions: ['customers.view'],
  },
  {
    path: `${routes.CUSTOMERS_PATH}/:customerId`,
    component: () => <CustomerDetailsPage />,
    fullScreenWidth: true,
    permissions: ['customers.view'],
  },
  {
    path: routes.ROLLING_CREDIT,
    component: () => <RollingCreditAdapter paddingTop="40px" />,
    permissions: ['rolling-credit'],
  },
  {
    path: routes.SPEND_CONTROLS,
    component: () => <SpendConrolTableInjected />,
    permissions: ['rolling-credit'],
  },
  {
    path: `${routes.INBOX_PATH}`,
    component: () => <InboxPage />,
    permissions: ['inbox.view'],
  },
  {
    path: '/search',
    component: () => <SearchResultPage />,
    permissions: ['search'],
  },
  {
    path: `${routes.ACCOUNTING_PATH}`,
    component: () => <AccountingPage />,
    permissions: ['accounting'],
  },
  {
    path: '/external',
    component: () => <ExternalPage />,
    permissions: ['external'],
  },
  {
    path: routes.SUBSCRIPTION_PATH,
    component: () => <SubscriptionPlanPage />,
    permissions: ['subscription'],
  },
  {
    path: routes.TEMPLATE_PATH,
    component: () => <TemplateDetailPage />,
    permissions: ['subscription'],
  },
  {
    path: '/integration-error',
    component: () => <IntegrationErrorMain />,
    permissions: ['customers.view'],
  },
]
